module.exports = __webpack_public_path__ + "img/IMG_0859.8cdb3e33.png";